import React from 'react';
import { SimpleUserView } from '../../../types/users';
import { UserId } from '../../../../mainv2/types/user';
import { UserProfileCell } from '../../../../commonv3/components/atoms/users/UserProfileCell';
import { Dropdown, SuggestionItem } from '../../atoms/forms/Dropdown';
import { ReviewerApis } from '../../../apis/reviewers';
import './reviewerSelector.module.scss';
import { Close } from '@material-ui/icons';
import { ReviewerIndexView } from '../../../types/reviewers';

type Props = {
    reviewer: SimpleUserView | null;
    reviewerSkillTypeId: number;
    onReviewerChange: (reviewerId: UserId | null) => any;
    metaAttributes?: object;
};

export const ReviewerSelector = ({ reviewer, onReviewerChange, reviewerSkillTypeId, metaAttributes }: Props) => {
    return (
        <div styleName="reviewer-selector" className="reviewer-selector" {...metaAttributes || {}}>
            <div styleName="assignment">{reviewer ? <UserProfileCell user={reviewer} /> : ''}</div>
            <Dropdown<ReviewerIndexView>
                type={reviewer ? 'primary' : 'danger'}
                styleName="dropdown"
                className="reviewer-selector-dropdown"
                showSearch={true}
                suggestions={(query) => ReviewerApis.findAll(query, [reviewerSkillTypeId])}
                renderSuggestion={(props) => (
                    <SuggestionItem {...props} data-reviewer-id={props.value.id}>
                        <UserProfileCell user={props.value} />
                    </SuggestionItem>
                )}
                onSuggestionClick={(selectedReviewer) => {
                    onReviewerChange(selectedReviewer ? selectedReviewer.id : null);
                }}
                showBottomTool={!!reviewer}
                renderBottomTool={() => (
                    <SuggestionItem onClick={() => onReviewerChange(null)}>
                        {/* If the reviewer is selected show the clear button */}
                        <div styleName="clear-button" className="clear-reviewer-button">
                            <Close styleName="close-icon" /> 選択を解除する
                        </div>
                    </SuggestionItem>
                )}
            >
                {!reviewer ? 'アサインする' : '変更する'}
            </Dropdown>
        </div>
    );
};
